export enum ECarrier {
    Unknown = 0,
    Imager = 1,
    LoadPort = 2,
    FixedCarriage = 3,
    MovingCarriage1 = 4,
    MovingCarriage2 = 5,
    Storage = 6, 
  }
  